if (!customElements.get('article-product-bar')) {
  customElements.define('article-product-bar', class ArticleProductBar extends HTMLElement {
    connectedCallback() {
      this.trigger = document.getElementById(this.dataset.trigger) || document.querySelector('.article-template');
      this.movesFloatingElements = this.dataset.position !== 'top';
      this.ticking = false;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onScrollHandler, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onScrollHandler);
      this.hide();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    update() {
      if (!this.trigger) return;

      const rect = this.trigger.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      // Show once the reader is into the article body, hide again once they have scrolled past it.
      const started = rect.top < viewportHeight * 0.5;
      const finished = rect.bottom < viewportHeight * 0.3;

      if (started && !finished) {
        this.open();
      } else {
        this.hide();
      }
    }

    open() {
      if (this.classList.contains('open')) return;
      this.classList.add('open');
      if (this.movesFloatingElements) document.body.classList.add('open-article-product-bar');
    }

    hide() {
      if (!this.classList.contains('open')) return;
      this.classList.remove('open');
      if (this.movesFloatingElements) document.body.classList.remove('open-article-product-bar');
    }
  });
}
